import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import * as _ from 'lodash';

/**
 * 单选
 */
@Component({
})
export default class RadioButton extends Vue {
  @Prop()
  public arr: Array<{
    value: any,
    text: string,
  }>;
  @Prop()
  public label: string;
  @Prop()
  public value;

  public handleClick(item) {
    this.$emit('input', item.value);
  }
}



// WEBPACK FOOTER //
// ./src/components/common/RadioButton/RadioButton.ts